import React from 'react';

import AssetManager from '@components/workbench/individual/asset_manager/main';
import Metadata from '@components/workbench/individual/metadata/metadata';

class MetadataExtractor extends React.Component {
  render() {
    return (
      <AssetManager extractMetadata>
        <Metadata />
      </AssetManager>
    );
  }
}

export default MetadataExtractor;
